const mutations = {
  markedJobs: (state, value) => {
    state.markedJobs = value
  },
  appliedJobs: (state, value) => {
    state.appliedJobs = value
  },
  jobs: (state, value) => {
    state.jobs = value
  },
  page: (state, value) => {
    state.page = value
  },
  pages: (state, value) => {
    state.pages = value
  },
  totalRecords: (state, value) => {
    state.totalRecords = value
  },
  showFilters: (state, value) => {
    state.showFilters = value
  }
}

export default mutations
